/**
 * Page principale du support - SuperAdmin
 * Gere la navigation entre liste, detail et creation
 */

import { useState } from 'react';
import { TicketList } from './TicketList';
import { TicketDetail } from './TicketDetail';
import { TicketCreateForm } from './TicketCreateForm';

type View = 'list' | 'detail' | 'create';

export function SupportPage() {
  const [view, setView] = useState<View>('list');
  const [selectedTicketId, setSelectedTicketId] = useState<string | null>(null);

  const handleSelectTicket = (id: string) => {
    setSelectedTicketId(id);
    setView('detail');
  };

  const handleCreateTicket = () => {
    setView('create');
  };

  const handleBack = () => {
    setView('list');
    setSelectedTicketId(null);
  };

  const handleTicketCreated = (ticketId: string) => {
    setSelectedTicketId(ticketId);
    setView('detail');
  };

  return (
    <div className="p-6">
      {view === 'list' && (
        <TicketList
          onSelectTicket={handleSelectTicket}
          onCreateTicket={handleCreateTicket}
        />
      )}

      {view === 'detail' && selectedTicketId && (
        <TicketDetail
          ticketId={selectedTicketId}
          onBack={handleBack}
        />
      )}

      {view === 'create' && (
        <TicketCreateForm
          onBack={handleBack}
          onSuccess={handleTicketCreated}
        />
      )}
    </div>
  );
}
